import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import { type FeedbackConfig } from './feedback.types';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class Feedback {
  readonly config = input.required<FeedbackConfig>();

  protected readonly headerTextConfig = computed(() => ({
    text: this.config().header,
    size: '2xl' as const,
    fontWeight: 'semibold' as const,
    alignment: 'center' as const,
  }));

  protected readonly subheadTextConfig = computed(() => ({
    text: this.config().subhead,
    size: 'base' as const,
    fontWeight: 'semibold' as const,
    alignment: 'center' as const,
  }));
}
